import { DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { AngularFireModule } from '@angular/fire';
import { AngularFireDatabaseModule } from '@angular/fire/database';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { ChartModule, HIGHCHARTS_MODULES } from 'angular-highcharts';
import windbarb from 'highcharts/modules/windbarb.src';
import { ToastrModule } from 'ngx-toastr';
import { AppComponent } from './app.component';
import { MeteogramComponent } from './meteogram/meteogram.component';
import { LocationService } from './shared/services/location.service';
import { WeatherDataComponent } from './weather-data/weather-data.component';

const config = {
  apiKey: 'AIzaSyCcN-HBpZKoV3dUUecM7_jy5S5TfWZMPtQ',
  authDomain: 'weather-data-demo-app.firebaseapp.com',
  databaseURL: 'https://weather-data-demo-app.firebaseio.com/',
  projectId: 'weather-data-demo-app'
};

export function highchartsModules(): [typeof windbarb]  {
  // Apply Highcharts modules to this array.
  return [windbarb];
}

export function getBaseUrl(): string {
  return document.getElementsByTagName('base')[0].href;
}

@NgModule({
  declarations: [
    AppComponent,
    MeteogramComponent,
    WeatherDataComponent
  ],
  imports: [
    AngularFireDatabaseModule,
    AngularFireModule.initializeApp(config),
    BrowserAnimationsModule,
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    ChartModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule.forRoot([
      { path: '', component: WeatherDataComponent, pathMatch: 'full' }
    ]),
    ToastrModule.forRoot()
  ],
  providers: [
    { provide: 'BASE_URL', useFactory: getBaseUrl },
    { provide: HIGHCHARTS_MODULES, useFactory: highchartsModules },
    DatePipe,
    LocationService
  ],
  bootstrap: [AppComponent]
})

export class AppModule {}
